/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

/* eslint-disable no-unused-vars */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {injectIntl} from 'react-intl';
import {AppsView} from 'cchome-apps';
import AppsUtils from './AppsUtils';
import {error, errorWithAction} from '../../components/ErrorToast/ErrorToast';
import TrackingService from '../../services/TrackingService';
import ThorUtils from '../../../utils/ThorUtils';
/* eslint-enable no-unused-vars */
import {routeSchemaMap} from './AppsConstants';
import {GROWTH_ROUTES} from '../Growth/growthConstants';
import {addMiniPlanModal} from '../../components/MiniPlanModal/MiniPlanModal';
import ErrorState from '../ErrorState/ErrorState';
import {ToDoView, ThroughlineView} from 'growth-todolist';
import './Apps.scss';
import PostIMSFetchService from '../../services/PostIMSFetchService';
import growthUtil from '../Growth/growthUtil';
// import LeftRail from '@cchome/home-left-rail/src/containers/LeftRail';

type Props = {
	locale: string;
	match: Object;
	env: string;
	history: any;
	profile: {
		subscriptionInfo: SubscriptionInfoType;
		productEntitlements: Array<string>;
		fulfilledEntitlements: Array<string>;
		profileTimeoutOrError: boolean | null | undefined;
		profileFetchFinished: boolean | null | undefined;
	};
	setOverwriteComponent: Function;
	isOpusWorkflow: Function;
	// leftRailOpen: boolean;
};

let TodoComp;
let ThroughlineComp;

class Apps extends Component<Props> {
	constructor(props: Props) {
		super(props);

		TodoComp = injectIntl(ToDoView);
		ThroughlineComp = injectIntl(ThroughlineView);
	}

	addClass(elem, classname) {
		if (elem) {
			const arr = elem.className.split(' ');
			if (arr.indexOf(classname) === -1) {
				elem.className += ` ${classname}`;
			}
		}
	}

	/**
	 * [getPathData grabs the relveant learn fields from the url]
	 * @returns {[none]}
	 */
	getPathData() {
		// const path = this.props.match.url.split('/');
		const path = window.location.pathname.split('/');
		return {
			mainAppsTab: path[2] ? path[2].toLowerCase() : undefined,
			product: path[3] ? path[3].toLowerCase() : undefined,
			pdpTab: path[4] ? path[4].toLowerCase() : undefined,
		};
	}

	componentDidMount() {
		const pathData = this.getPathData();
		if (pathData.mainAppsTab === 'download') {
			window.location = window.location.pathname as any;
		}
	}

	getPlanCode() {
		return this.props.profile.subscriptionInfo && this.props.profile.subscriptionInfo.planCode;
	}

	getPlanStatus() {
		return this.props.profile.subscriptionInfo && this.props.profile.subscriptionInfo.status;
	}

	getTermStartDate() {
		return this.props.profile.subscriptionInfo && this.props.profile.subscriptionInfo.termStartDate;
	}

	getCustomerSegment() {
		return this.props.profile.subscriptionInfo && this.props.profile.subscriptionInfo.customerSegment;
	}

	handleRouteChange = (route: string) => {
		const {history} = this.props;
		history.push(route);
	};

	render() {
		const pathObject = this.getPathData();
		const {env, locale, profile, history} = this.props;
		const {profileTimeoutOrError, profileFetchFinished} = profile;
		if (!(profileFetchFinished || profileTimeoutOrError)) {
			return null;
		}

		let growthPassProps: any = {
			history,
			imsData: AppsUtils.getIMSData(),
			locale,
			environment: env,
			location: window.location,
			routePath: '',
		};

		if (growthUtil.isTodoWorkflow()) {
			if (!window.growthTrackingService) {
				window.growthTrackingService = new TrackingService();
			}

			return <TodoComp {...growthPassProps} />;
		}

		if (growthUtil.isThroughlineWorkflow()) {
			const routePath = GROWTH_ROUTES.THROUGHLINE;
			const isSinglePsUser
				= window.cchome.util.hasFeature('temp_enable_throughline_singlePs')
				&& growthUtil.isUrlParamTrue('isSinglePs');
			const throughlineType = growthUtil.getThroughlineType();

			growthPassProps = {...growthPassProps, routePath, isSinglePsUser, throughlineType};

			AppsUtils.hideTransitionLoader();

			if (growthUtil.isUrlParamTrue('isFromDownload')) {
				return <ThroughlineComp {...growthPassProps} />;
			}

			const appsContainer = document.getElementsByClassName('throughline')[0] as HTMLElement;
			if (appsContainer) {
				AppsUtils.removeClass(appsContainer, 'throughline');
			}

			return <ErrorState.component {...this.props} />;
		}

		return (
			<div id='apps_section' className='apps-container-wrapper'>
				{/* {hasLeftRail && (
					<LeftRail
						open={this.props.leftRailOpen}
						handleRouteChange={this.handleRouteChange}
						overlay
						header
					/>
				)} */}

				<AppsView
					environment={env}
					imsData={AppsUtils.getIMSData()}
					locale={locale}
					routeSchema={routeSchemaMap}
					routeParams={pathObject}
					routing
					error={error}
					errorWithAction={errorWithAction}
					setOverwriteComponent={component => this.props.setOverwriteComponent(component)}
					planCode={this.getPlanCode()}
					planStatus={this.getPlanStatus()}
					profile={profile}
					customerSegment={this.getCustomerSegment()}
					profileTimeoutOrError={profileTimeoutOrError}
					profileFetchFinished={profileFetchFinished}
					thorProductsList={ThorUtils.getProductsList()}
					preFetchedRestAPIResponses={PostIMSFetchService.getResponseForKey}
					addMiniPlanModal={addMiniPlanModal.bind(this)}
				/>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		profile: state.profile,
		// leftRailOpen: state.uistore.leftRailOpen,
	};
}

export default {
	component: connect(mapStateToProps)(Apps),
};
